<template>
    <div v-if="!record" class="fail-link">
        <img src="@/assets/img/mobile/page/fail-link.png" alt="">
    </div>


    <a-spin :spinning="!record" v-else>
        <div v-if="record" class="model-info">
            <div v-html="record.content">

            </div>

            <div v-if="annex.length > 0" class="download-file">
                <template v-for="(url) in annex" :key="url">
                    <div class="df annex" @click="handleDownLoadFile(url)">
                        <img src="@/assets/img/mobile/page/PDF.png">
                        <div class="file-name">{{ url.slice(url.lastIndexOf("/") + 1, url.length) }}</div>
                        <div class="download-name">点击下载</div>
                    </div>
                </template>
            </div>

            <about v-if="showAbout && record" :type="record.catalog.replace('渠道', '相关信息')"></about>
        </div>


    </a-spin>
</template>

<script>
import { computed, defineComponent, nextTick, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getOne, addProductInfoPV, saveProductInfo } from '@/request/view/productPublicityDept.js';
import { aboutType } from '../Literature/data';
import about from './components/about.vue';
import { useStore } from 'vuex';

export default defineComponent({
    components: { about },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const record = ref(null);

        const annex = ref([])

        const user = useStore().state.user.user;

        const countPv = () => {

            if (user && user.id) {
                saveProductInfo({
                    id: record.value.id,
                    sharingFrequency: Number(record.value.sharingFrequency) + 1,
                })
            } else {
                addProductInfoPV({
                    productInfoId: record.value.id
                })
            }
        }

        const setClickEventByVideo = () => {
            Array.from(document.querySelectorAll('video')).forEach((dom) => {
                dom.addEventListener('touchstart', function () {
                    this.play();
                });
            });
        };

        const showAbout = computed(() => record.value !== aboutType);

        const getData = () => {
            record.value = null;
            annex.value.length = 0;
            const { id } = route.query;

            getOne({
                id
            }).then((res) => {
                if (res.code === 200 && res.message === '成功' && res.data) {
                    const { isDeactivate, model, product } = res.data;


                    if (isDeactivate) return;
                    record.value = res.data;

                    const swanMask = 'https://visionhealthmed.com/static/img/video-mask-swan.png';
                    const columbaMask = 'https://visionhealthmed.com/static/img/video-mask-columba.png';

                    let mask = '';

                    if (decodeURI(product).indexOf('Swan') !== -1) {
                        mask = swanMask;
                        document.title = '眼科光学生物测量仪';
                    }
                    if (decodeURI(product).indexOf('columba') !== -1) {
                        mask = columbaMask;
                        document.title = '视力筛查仪';
                    }
                    if (decodeURI(product).indexOf('LanW') !== -1) {
                        document.title = '蓝鲸';
                    }
                    if (decodeURI(product).indexOf('Starton') !== -1) {
                        document.title = '星豚';
                    }
                    if (decodeURI(product).indexOf('tableLamp') !== -1) {
                        document.title = '春晖台灯';
                    }
                    if (decodeURI(product).indexOf('Grus') !== -1) {
                        document.title = '干眼和角膜地形图测试仪';
                    }
                    if (decodeURI(product).indexOf('Draco') !== -1) {
                        document.title = '眼科光学生物测量仪';
                    }
                    if (decodeURI(product).indexOf('视光相关信息')!== -1) {
                        document.title = decodeURI(model);
                    }

                    record.value.content = record.value.content.replace(/poster/g, `poster="${mask}"`).replace(/=""/g, '');

                    if (record.value.colorPageFile) {
                        annex.value.push(...record.value.colorPageFile.split(','))
                    }
                    countPv();
                    nextTick(() => {
                        setClickEventByVideo();
                    });
                }
            });
        };

        watch(() => route, (val) => {
            if (val.path === '/branddetails') {
                getData();
            }
        }, {
            immediate: true,
            deep: true,
        });

        const handleDownLoadFile = (url) => {
            const ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('micromessenger') !== -1) {
                // 在微信内置浏览器中，直接跳转到手机自带浏览器中下载文件
                window.location.href = url;
            } else {
                // 不在微信内置浏览器中，直接打开下载链接
                window.open(url, '_blank');
            }
        }


        return {
            annex,
            record,
            showAbout,
            handleDownLoadFile,
        };
    }
});
</script>

<style lang="less" scoped>
.model-info {
    width: 100vw;
    height: 100vh;
    overflow: scroll;

    :deep(img) {
        width: 100vw;
        height: auto;
    }

    :deep(video) {
        width: 8.54rem;
        height: 4.62rem;
        margin-left: 0.84rem;
        border-radius: 20px;
    }

    :deep(.wrapper-video) {
        position: relative;
    }
}

.download-file {
    display: block;
    width: 7.49rem;
    margin: 1rem auto 0.65rem;

    .annex {
        padding: 0.3rem 0.4rem;
        align-items: center;
        margin-bottom: 0.3rem;
        background: #f4f7fa;
        border-radius: 0.2rem;

        img {
            width: 0.66rem;
            height: 0.66rem;
            margin-right: 0.2rem;
        }

        .file-name {
            width: 4rem;
            text-overflow: ellipsis;
            text-wrap: nowrap;
            overflow: hidden;
            margin-right: 0.5rem;
        }

        .download-name {
            color: #2c8bf2;
        }
    }

}

.fail-link {
    padding-top: 1.33rem;

    img {
        margin-left: 2.23rem;
        display: block;
        width: 4.53rem;
        height: 4.1rem;
    }
}
</style>
